import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addhiresource',
  templateUrl: './addhiresource.component.html',
  styleUrls: ['./addhiresource.component.css']
})
export class AddhiresourceComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname: string = "HiResource";

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   


//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
hiresourceColl:any=[];
hiresourceBO:any={};
hiresourceid:number=0

hiresourceform=new FormGroup({
  hiresourceid:new FormControl(0),          
  hiresourcename:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


@Input() ischild :boolean=false;
@Input() ischildadd :boolean=false;
@Input() ischildkey :number=0
@Output() childChanged = new EventEmitter<number>();


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.hiresourceid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.hiresourceform.reset();
       this.fnInitializeFormGroup(); 

       if(this.hiresourceid>0){
         this.fngetHiResource();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.hiresourceid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}  
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.hiresourceform.setValue({
    hiresourceid:0,    
    hiresourcename:'',
     inactive:false              
   })
}

//Get 
fngetHiResource() { 
  if (this.showProgress) {
    return;
  }         
     var data = {
       'hiresourceid':this.hiresourceid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getHiResource(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){ 
          this.fnHideProgress();
 
           this.hiresourceColl=res.json().result;
           var editdata = this.hiresourceColl[0];        
           this.fnEditMode(editdata);
           this.hiresourceBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{          
      this.fnHideProgress();

       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{
    if (this.saveloading) {
      return;
    }
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.hiresourceform.valid){
         //Check
         this.saveloading = true;
         var data = {
               'hiresourceid': this.hiresourceid,                      
               'hiresourcename':this.hiresourceform.get('hiresourcename').value, 
               'inactive':this.hiresourceform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckHiResource(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.hiresourceform.get('hiresourceid').value>0){
                       //Update 
                       this.fnSetHiResource(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertHiResource(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;
                       this.hiresourceform.controls['hiresourcename'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertHiResource(data){    
 
   this.appService.fnInsertHiResource(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){

          
          this.ischildkey=res.json().result[0][0].hiresourceid;
          this.ischildadd=true;

           this.toastr.success('', "The new hiresource has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.hiresourcename);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetHiResource(data){    

this.appService.fnSetHiResource(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The hiresource has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.hiresourceid,data.hiresourcename);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  if(this.ischild===false){
    this.router.navigate(['/HiResource']);
  }
  else{
    var pBO:any={
      isadd:this.ischildadd,
      childkey:this.ischildkey,
      doctype:'HIRESOURCE'    
    }
    this.childChanged.emit(pBO);
  }

}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.hiresourceform.setValue({ 
  hiresourceid:deptBO.hiresourceid,     
  hiresourcename:deptBO.hiresourcename,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
} 
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}








}
